// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The parts of the source browse card keyed off its kind.
 *
 * The layout is ../catalog/CatalogBrowseLayout.module.css, shared with the
 * other three browse pages; only kind-keyed rules live here, the same split
 * AgentCatalogBrowseCard.module.css and PackageBrowseCard.module.css use.
 *
 * There is ONE key, not one per provider. On this page every card is a portal,
 * so a per-provider colour would carry no information while costing four new
 * hues in a palette that has no room left - see --curio-kind-source-fg. The
 * provider is a neutral badge instead, which is legible without learning a
 * code.
 */

.bn_FGTYlCwoB7LxNHoQG { background: var(--curio-kind-source-fg); }

/* Declared here so \`.cardActive.card_discovery\` is a valid compound WITHIN this
   module: CSS modules hash per file, so the shared \`.cardActive\` cannot
   satisfy it. Both classes are applied together and agree, because both read
   the one token. Same reason AgentCatalogBrowseCard.module.css does it. */
.J6aVMkpsWtIv4jIDixzT { box-shadow: var(--curio-shadow-browse-card-raised); }
.J6aVMkpsWtIv4jIDixzT.ncaAe4xoC4uLYkZfx9uG { border-color: var(--curio-kind-source-fg); }

/* The source's mark, sitting where the other catalogs' cards start their
   title block. Pulled up into the body's own padding so the icon and the
   title share a baseline grid with the peer pages. */
.Y2B2IXolESSqkGciGFVe {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
  min-width: 0;
}

.HMO9FzDW_zgw0ddCgvfi {
  min-width: 0;
  flex: 1;
}

.HMO9FzDW_zgw0ddCgvfi .UGarPgmayMZ06noaNlqK {
  margin-top: 0;
}

/* A token-present / token-needed marker. Deliberately not the danger colour:
   a source needing a token is a next step, not an error. */
.FsnJAsy3pi1FnZ5sTPxQ {
  height: 16px;
  border-radius: 8px;
  padding: 0 7px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.rAhcDCPm66RsRR7RXlMU {
  background: var(--curio-role-installed-bg);
  color: var(--curio-role-installed-fg);
}

.TIXLVSDu1LNdYMYP4VO3 {
  background: var(--curio-warning-bg);
  color: var(--curio-warning-text);
}
`, "",{"version":3,"sources":["webpack://./src/pages/discovery/DiscoverySourceCard.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;;AAEF,wBAAmB,uCAAuC,EAAE;;AAE5D;;;0EAG0E;AAC1E,wBAAc,kDAAkD,EAAE;AAClE,6CAA6B,yCAAyC,EAAE;;AAExE;;qDAEqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;2DAC2D;AAC3D;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC","sourcesContent":["/*\n * The parts of the source browse card keyed off its kind.\n *\n * The layout is ../catalog/CatalogBrowseLayout.module.css, shared with the\n * other three browse pages; only kind-keyed rules live here, the same split\n * AgentCatalogBrowseCard.module.css and PackageBrowseCard.module.css use.\n *\n * There is ONE key, not one per provider. On this page every card is a portal,\n * so a per-provider colour would carry no information while costing four new\n * hues in a palette that has no room left - see --curio-kind-source-fg. The\n * provider is a neutral badge instead, which is legible without learning a\n * code.\n */\n\n.strip_discovery { background: var(--curio-kind-source-fg); }\n\n/* Declared here so `.cardActive.card_discovery` is a valid compound WITHIN this\n   module: CSS modules hash per file, so the shared `.cardActive` cannot\n   satisfy it. Both classes are applied together and agree, because both read\n   the one token. Same reason AgentCatalogBrowseCard.module.css does it. */\n.cardActive { box-shadow: var(--curio-shadow-browse-card-raised); }\n.cardActive.card_discovery { border-color: var(--curio-kind-source-fg); }\n\n/* The source's mark, sitting where the other catalogs' cards start their\n   title block. Pulled up into the body's own padding so the icon and the\n   title share a baseline grid with the peer pages. */\n.identity {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 14px;\n  min-width: 0;\n}\n\n.identityText {\n  min-width: 0;\n  flex: 1;\n}\n\n.identityText .cardTitle {\n  margin-top: 0;\n}\n\n/* A token-present / token-needed marker. Deliberately not the danger colour:\n   a source needing a token is a next step, not an error. */\n.authChip {\n  height: 16px;\n  border-radius: 8px;\n  padding: 0 7px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.authChipReady {\n  background: var(--curio-role-installed-bg);\n  color: var(--curio-role-installed-fg);\n}\n\n.authChipNeeded {\n  background: var(--curio-warning-bg);\n  color: var(--curio-warning-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"strip_discovery": `bn_FGTYlCwoB7LxNHoQG`,
	"cardActive": `J6aVMkpsWtIv4jIDixzT`,
	"card_discovery": `ncaAe4xoC4uLYkZfx9uG`,
	"identity": `Y2B2IXolESSqkGciGFVe`,
	"identityText": `HMO9FzDW_zgw0ddCgvfi`,
	"cardTitle": `UGarPgmayMZ06noaNlqK`,
	"authChip": `FsnJAsy3pi1FnZ5sTPxQ`,
	"authChipReady": `rAhcDCPm66RsRR7RXlMU`,
	"authChipNeeded": `TIXLVSDu1LNdYMYP4VO3`
};
export default ___CSS_LOADER_EXPORT___;
